import tw, { styled } from 'twin.macro';

export const SectionWrapper = styled.section`
  ${tw``}
`;
export const SectionHeader = styled.header`
  ${tw`flex justify-between items-center mb-4`}
`;
export const CardsWrapper = styled.div`
  ${tw`grid grid-cols-1 gap-4`}
`;
export const SeeMoreButtonWrapper = styled.div`
  ${tw`grid place-items-center mt-4`}
`;
export const ModalHeaderWrapper = styled.div`
  ${tw`hidden md:flex border-b border-neutral-40 w-full justify-between items-center py-[10.5px] px-4 lg:(p-3 pl-10)`}
`;
export const ModalCardsWrapper = styled.div`
  ${tw`mt-10 pb-2 px-4 mx-auto w-full grid grid-cols-1 gap-4 md:(max-h-[600px]) lg:(grid-cols-3 px-10)`}
`;
export const SpinnerWrapper = styled.div`
  ${tw`grid place-items-center w-full pt-10 pb-2`}
`;
export const ModalContentWrapper = styled.div`
  ${tw`w-full h-full md:(p-10 pb-10)`}
`;
export const ActiveComponentWrapper = styled.div<{ isVisible?: boolean }>`
  ${tw`h-full`}
  ${({ isVisible }) => (isVisible ? tw`block` : tw`hidden`)}
`;
